import ScoreIcon from './ScoreIcon'
import Slider from './Slider'

function Selector({
    score,
    setScore,
    getColorForScore,
    getIconForScore,
    getDescriptionForScore,
    label
}) {
    const handleNumberInputChange = (e) => {
        const value = e.target.value;
        if (value === '') {
            setScore(0);
            return;
        }
        const numValue = parseFloat(value);
        if (!isNaN(numValue)) {
            const clampedValue = Math.max(0, Math.min(10, numValue));
            setScore(clampedValue);
        }
    };

    const handleNumberInputBlur = (e) => {
        const value = parseFloat(e.target.value) || 0;
        const clampedValue = Math.max(0, Math.min(10, value));
        setScore(clampedValue);
    };

    return (
        <div className="form-content pain-entry">
            <p style={{ fontSize: "14px", color: "#374151", marginBottom: "8px" }}>
                {label}
            </p>

            <div style={{ display: "flex", flexDirection: "column", gap: "0" }}>

                <div style={{ display: "flex", justifyContent: "center" }}>
                    <Slider
                        value={score}
                        setValue={setScore}
                        getColorForScore={getColorForScore}
                        getIconForScore={getIconForScore}
                    />
                </div>
                <div style={{ textAlign: "center", position: "relative", top: "0px" }}>
                    <div
                        style={{
                            display: "inline-flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "0.25rem",
                            width: "6rem",
                            height: "6rem",
                            borderRadius: "50%",
                            color: "white",
                            fontSize: "1.5rem",
                            fontWeight: "bold",
                            boxShadow: "0 10px 15px rgba(0,0,0,0.1)",
                            transition: "all 0.3s ease",
                            backgroundColor: getColorForScore(score)
                        }}
                    >
                        <div style={{
                            fontSize: "2rem",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center"
                        }}>
                            <ScoreIcon score={score} getIconForScore={getIconForScore} />
                        </div>
                        <input
                            type="number"
                            min="0"
                            max="10"
                            step="0.1"
                            value={score}
                            onChange={handleNumberInputChange}
                            onBlur={handleNumberInputBlur}
                            style={{
                                width: "100%",
                                background: "transparent",
                                color: "white",
                                fontSize: "1.5rem",
                                fontWeight: "bold",
                                textAlign: "center",
                                border: "none",
                                outline: "none",
                                WebkitAppearance: "none",
                                MozAppearance: "textfield"
                            }}
                        />
                    </div>
                    <div style={{ marginTop: "0.75rem" }}>
                        <span
                            style={{
                                fontSize: "1.125rem",
                                fontWeight: 500,
                                transition: "color 0.3s ease",
                                color: getColorForScore(score)
                            }}
                        >
                            {getDescriptionForScore(score)}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Selector;